import React, {Component} from 'react';
import { unix_to_datestring } from '../../../../ClientUtils';
import {Line} from 'react-chartjs-2';
import axios from "axios";
const root_string = require("../../../../config.json")["root_string"];


class N_holders_graph extends Component {

  constructor(props) {
    super(props);
    this.state = {
      labels: [],
      V1_data: [],
      V2_data: [],
      Overall_data: []
    };
  }

  componentDidMount() {
    axios
      .get(root_string + '/api/data_api/n_unique_holders')
      .then(res => {
        let labels = [];
        let V1_data = [];
        let V2_data = [];
        let Overall_data = [];
        for (let label of Object.keys(res.data["data"])) {
          labels.push(unix_to_datestring(label));
          V1_data.push(res.data["data"][label]["V1_n_unique_holders"]);
          V2_data.push(res.data["data"][label]["V2_n_unique_holders"]);
          Overall_data.push(res.data["data"][label]["Overall_n_unique_holders"]);
        }
        this.setState({
          labels: labels,
          V1_data: V1_data,
          V2_data: V2_data,
          Overall_data: Overall_data
        })
      })
      .catch(err => {
        console.log("Error from Homepage Top api");
      })
  };


  render() {
    const data = {
      labels: this.state.labels,
      datasets: [
        {
          label: 'Overall N Holders',
          fill: false,
          lineTension: 0.1,
          borderWidth: 2.5,
          backgroundColor: 'rgb(203,241,243)',
          borderColor: 'rgb(203,241,243)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgb(203,241,243)',
          pointBackgroundColor: '#cbf1f3',
          pointBorderWidth: 2,
          pointHoverRadius: 10,
          pointHoverBackgroundColor: 'rgb(203,241,243)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 0,
          pointHitRadius: 10,
          data: this.state.Overall_data
        },
        {
          label: 'V1 N Holders',
          lineTension: 0.1,
          borderWidth: 2.5,
          fill: false,
          backgroundColor: 'rgb(250,211,218)',
          borderColor: 'rgb(250,211,218)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgb(250,211,218)',
          pointBackgroundColor: '#fad3da',
          pointBorderWidth: 2,
          pointHoverRadius: 10,
          pointHoverBackgroundColor: 'rgb(250,211,218)',
          pointHoverBorderColor: 'rgb(250,211,218)',
          pointHoverBorderWidth: 2,
          pointRadius: 0,
          pointHitRadius: 10,
          data: this.state.V1_data
        },
        {
          label: 'V2 N Holders',
          fill: false,
          lineTension: 0.1,
          borderWidth: 2.5,
          backgroundColor: 'rgb(196,240,208)',
          borderColor: 'rgb(196,240,208)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgb(196,240,208)',
          pointBackgroundColor: '#c4f0d0',
          pointBorderWidth: 2,
          pointHoverRadius: 10,
          pointHoverBackgroundColor: 'rgb(196,240,208)',
          pointHoverBorderColor: 'rgb(196,240,208)',
          pointHoverBorderWidth: 2,
          pointRadius: 0,
          pointHitRadius: 10,
          data: this.state.V2_data
        },
      ]
    };

    const options = {
      maintainAspectRatio: false,
      tooltips: {
        mode: 'x-axis'
      },
      scales: {
        yAxes: [{
          scaleLabel: {
            display: true,
            labelString: "Number of Addresses",
            ticks: {
              fontSize: 15
            },
            fontSize: 18
          },
          gridLines: {
            display: false,
          },
        }],
        xAxes: [{
          type: 'time',
          ticks: {
            autoSkip: true,
          },
          scaleLabel: {
            display: true,
            labelString: "",
            ticks: {
              fontSize: 15
            },
            fontSize: 18
          },
          gridLines: {
            display: false
          }
        }]
      },
      responsive: true,
    }
    return (
      <div className="chart-container" style={
        {
          backgroundColor: "#192734",
          padding: "30px",
          borderRadius: "5px"
        }
      }>
        <h2>Cumulative Number of Unique oToken Holders</h2>
        <Line data={data} options={options} height={400}/>
      </div>
    );
  }
}

export default N_holders_graph;
